import React, { useState, useEffect, useRef } from 'react';
import { getRouteFromPath } from '../../../Routes';
import {
  hasPermissionAdmin,
  pathRedirect,
} from '../../../elements/lib/hasPermissionAdmin';
import { pathTo } from '../../../Routes';
import { Redirect } from 'react-router-dom';
import { Translation } from 'react-i18next';
import QueryString from '../../../../../lib/QueryString';
import DocumentHead from '../../../elements/components/DocumentHead';
import Logger from '../../../../../lib/Logger';
import scrollToTop from '../../../elements/lib/scrollToTop';
import CognitoFormAdminHeaderScreen from './CognitoFormAdminHeaderScreen';
import CognitoFormsAdminListTabs from '../containers/CognitoFormsAdminListTabsContainer';
import CognitoFormModalFormAdmin from '../containers/CognitoFormModalFormAdminContainer';
import { MixpanelTracker } from '../../../../../lib/Mixpanel';

function CognitoFormsAdminScreen({ showForm, role, ...props }) {
  const [redirect, setRedirect] = useState(null);
  const prevProps = useRef();

  const limit = parseInt(
    props.match.params.limit ? props.match.params.limit : 10
  );

  const page = parseInt(props.match.params.page ? props.match.params.page : 1);

  const { order, type, ...filter } = QueryString.parse(props.location.search);

  useEffect(() => {
    scrollToTop();
  }, []);

  useEffect(() => {
    prevProps.current = props;
  });

  useEffect(() => {
    const route = getRouteFromPath(props.location.pathname);
    const screen = hasPermissionAdmin();

    if (
      prevProps.current &&
      props.partnershipId !== prevProps.current.partnershipId
    ) {
      if (route.screen !== pathRedirect(screen)[0]) {
        setRedirect(pathRedirect(screen)[0]);
      }
    }
  }, [props.location.pathname, props.partnershipId]);

  const trackerActions = (eventMixpanel, params = {}) => {
    if (role !== 1) {
      MixpanelTracker.mixpanelTrack(eventMixpanel, {
        partnershipName: props.partnershipName ?? 'No partnership',
        partnershipId: props.partnershipId ?? 'No partnership',
        ...params,
      });
    }
  };

  if (redirect) {
    return <Redirect to={pathTo(redirect)} />;
  }

  return (
    <Translation>
      {(t) => (
        <>
          <DocumentHead title={t('cognito_forms_admin_route_list')} />
          <CognitoFormAdminHeaderScreen
            showForm={showForm}
            trackerActions={trackerActions}
          />
          <CognitoFormsAdminListTabs
            page={page}
            limit={limit}
            order={order || 'updated_at.desc'}
            filter={type ? { type, ...filter } : { type: 1, ...filter }}
            trackerActions={trackerActions}
          />

          <CognitoFormModalFormAdmin
            trackerActions={trackerActions}
            page={page}
            limit={limit}
            filter={type ? { type, ...filter } : { type: 1, ...filter }}
            order={order || 'updated_at.desc'}
          />
        </>
      )}
    </Translation>
  );
}

export default CognitoFormsAdminScreen;

Logger.log('silly', `CognitoFormsAdminScreen loaded.`);
